import { render, staticRenderFns } from "./ContactsViewerButton.vue?vue&type=template&id=54b083d6"
import script from "./ContactsViewerButton.vue?vue&type=script&lang=js"
export * from "./ContactsViewerButton.vue?vue&type=script&lang=js"
import style0 from "./ContactsViewerButton.vue?vue&type=style&index=0&id=54b083d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports